import React, { Component } from "react";
import { ButtonToolbar, Button, Form, Image, Row } from "react-bootstrap";
import { Field } from "../../component/FieldComponent";
import { get, isFunction } from "lodash";
import ForwardToTeam from "./forwardToTeam";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  setIssueStatusAction,
  postCommentAction,
  replyAction,
  issueClarificationAction
} from "../../actions/issuesListAction.actions";
import { getIssueList } from "../../actions/common.action";
import { bindActionCreators } from "redux/es/redux";
import { modifyDataForPost } from "./helper";
import {
  ERROR_MSG,
  FILE_FORMATS,
  STATUS,
  MAX_CHARACTER_LIMIT
} from "../../constant";
import ReassignForClarification from "./reassignForClarrification";
import MarkAsDuplicate from "./markAsDuplicate";
import ChangeStatus from "./changeStatus";
import AddDecision from "../agendaDetails/AddDecision.issueList";
import {
  getIssueMeetingByIdAction,
  getIssueDetails
} from "../../actions/issueDetail.action";
import { withRouter } from "react-router-dom";
import LoaderTemplate from "../../component/LoaderTemplate";
import { ActionLoaderTemplate } from "../../component/LoadersTemplate";
import DisplayByPermission from "../../component/DisplayByPermission";
import { LoaderPage } from "../../component/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  changeProjectStatus,
  getProjectDetails
} from "../../actions/projectDetail.action";
import {
  UploadAttachmentsWithTitleComponent,
  DisplayAttachmentsNew,
  DisplayAttachments
} from "../reusableComponent";
import IconPin from "../../assets/icon-pin.png";
import { unHoldIssueAction } from "../../actions/issues.action";
import AddDecisionConfirmationModal from "./addDecisionCofirmationModal";
import { getAgendaIssueAction } from "../../actions/mom.action";
import { handleLanguage, handlePaste, handleQuillLanguage } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import InfoIcon from "../../assets/small-info-icon.svg";
import TooltipComponent from "../../component/TooltipComponent";
import uparrow from "../../assets/uparrowsvg.svg";
import downarrow from "../../assets/downarrowsvg.svg";
import DeleteIcon from "../../assets/delete_icon.svg";
import { getLocalstorage } from "../../helper";
import { DatePicker } from "../../component/DatePickerIssueResolution";
import { toDate } from "date-fns";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import htmlToFormattedText from "html-to-formatted-text";
import Delta from "quill-delta";
import { ConfirmationComponent } from "../ConfirmationComponent";
const FIXED_ACTIONS = {
  "REASSIGN FOR CLARIFICATION": "REASSIGN FOR CLARIFICATION",
  "FORWARD TO TEAM": "FORWARD TO TEAM",
  REPLY: "REPLY",
  "ADD DECISION": "ADD DECISION",
  Mark_As_Duplicate: "Mark_As_Duplicate"
};

let severity = {
  PRIMARY: "btn-orange",
  SECONDARY: "btn-blue",
  TERNARY: "btn-orange-invert",
  default: "btn-orange"
};

const ACTION_TYPE = "WITH_COMMENT";

const MESSAGES_CONSTANT = {
  "Verify and Send for Consideration":
    "Verify & assign to PMG for further action",
  "Send for Under Process":
    "Verify & assign to its corresponding Recipient Ministry/State",
  "Send to Decision": "Assign to PMG for confirming the resolution of issue",
  "Add Decision": "Add decision taken in meeting or by higher authority",
  Reply: "Reply on requested clarification",
  "Forward to Team": "Forward to my team(s) for further action",
  "Reject Issue": "Not valid and outside the ambit of PMG",
  Resolve: "Confirm issue resolution and assign to PMG for closure",
  Hold: "Issue on hold and can't be part of PMG monitoring for the time being",
  "Reassign For Clarification":
    "Reassign to other stakeholder for issue/update clarification",
  Unhold: "Unhold to revert the issue to its previous stage",
  addMoreIssue: "Add Issue",
  markAsDuplicate: "Mark As Duplicate",
  updateStatus: "Add latest status update on the issue"
};

const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
class IssueUpdateStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: "",
      files: [],
      showAddDecisionConfirmationModal: false,
      agendasAssociatedWithIssue: [],
      checkAgenda: true,
      canUploadVideo: true,
      languageError: null,
      pasteError: false,
      pastedText: "",
      displaystatus: 0,
      updatestatusloader: false,
      textvalidation: true,
      rejectissue: "",
      tenitiveIssueResolveDate: "",
      tenitiveDateError: true,
      showCommentPopUp: false
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { resetAction } = nextProps;
    // eslint-disable-next-line no-unused-expressions
    resetAction;
  }

  componentDidUpdate(prevProps) {
    if (!this.matchersAttached && this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor();
      quill.clipboard.addMatcher("img", () => new Delta());
      quill.clipboard.addMatcher("a", node =>
        //new Delta().insert(node.innerText)
        new Delta().insert(node.textContent || "")
      );
      this.matchersAttached = true;
    }
  }

  onChangemarkAsdup = (value, key) => {
    localStorage.setItem("DisplayButton", "0");
    if (
      value == "REASSIGN FOR CLARIFICATION" ||
      "FORWARD TO TEAM" ||
      "Mark_As_Duplicate"
    ) {
      this.props.onCloseButton("1");
      this.props.markDuplicateBTN("1");
    }
    if (value == "") {
      this.props.onCloseButton("0");
    }

    this.setState({ [key]: value }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
    if (key === "comment") {
      if (value.length > MAX_CHARACTER_LIMIT) {
        value = value.slice(0, MAX_CHARACTER_LIMIT);
      }
    }
  };
  onBlur = value => {};
  onChange = (value, key) => {
    this.setState({ [key]: value, textvalidation: true }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
    if (key === "comment") {
      if (value.length > MAX_CHARACTER_LIMIT) {
        value = value.slice(0, MAX_CHARACTER_LIMIT);
      }
    }
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };
  handleButtonClose = () => {
    this.props.onCloseButton("0");
  };
  handleMarkBTN = () => {
    this.props.markDuplicateBTN("0");
  };

  extractDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    console.log("date", date);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    console.log("month", month);
    const day = String(date.getDate()).padStart(2, "0");
    console.log("day", day);

    return `${year}-${month}-${day}`;
  }

  handleSubmitClick = () => {
    const {
      issueDetails: { ministryOrState, tentativeResolutionDateMandatory }
    } = this.props;

    const { comment, tenitiveIssueResolveDate } = this.state;

    const plainText = comment ? comment.replace(/<[^>]*>/g, "").trim() : "";

    // ✅ Make flags = VALIDATION (true = valid)
    let textvalidation = !!plainText;
    let tenitiveDateError = true; // default true (valid)

    if (ministryOrState && tentativeResolutionDateMandatory) {
      tenitiveDateError = !!tenitiveIssueResolveDate;
    }

    // ❌ If any invalid → show error & stop
    if (!textvalidation || !tenitiveDateError) {
      this.setState(prevState => ({
        textvalidation,
        tenitiveDateError,
        error: {
          ...prevState.error,
          comment: {
            error: !textvalidation,
            message: !textvalidation ? ERROR_MSG.DEFAULT_MSG : ""
          }
        }
      }));
      return;
    }

    // ✅ All valid → clear error (both true)
    this.setState({
      textvalidation: true,
      tenitiveDateError: true
    });

    // ✅ Open modal
    this.toggleApprovePopUp();
  };
  onPostComment = () => {
    this.setState({ showCommentPopUp: false });
    const {
      issueDetails: { id, ministryOrState, tentativeResolutionDateMandatory },
      postCommentDispatch,
      callApiOnSuccess
    } = this.props;
    const { files, comment, tenitiveIssueResolveDate } = this.state;

    // Strip HTML tags and trim to check for actual text
    const plainText = comment ? comment.replace(/<[^>]*>/g, "").trim() : "";

    // error
    if (ministryOrState && tentativeResolutionDateMandatory) {
      if (
        !plainText ||
        this.state.tenitiveIssueResolveDate === undefined ||
        this.state.tenitiveIssueResolveDate === ""
      ) {
        if (
          this.state.tenitiveIssueResolveDate === undefined ||
          this.state.tenitiveIssueResolveDate === ""
        ) {
          this.setState({
            tenitiveDateError: false
          });
        }
        this.setState(prevState => ({
          languageError: false,
          pasteError: false,
          textvalidation: false,
          error: {
            ...prevState.error,
            comment: {
              error: !plainText,
              message: !plainText ? ERROR_MSG.DEFAULT_MSG : ""
            }
          }
          //tenitiveDateError: false
        }));
      } else {
        if (ministryOrState) {
          const modifyDate = this.extractDate(tenitiveIssueResolveDate);
          //const modifyDate = toDate(modifyDateString);
          const modifyData = modifyDataForPost({
            files,
            comment,
            id,
            modifyDate
          });
          this.setState(
            {
              isCommentLoading: STATUS.LOADING
            },
            async () => {
              const resp = await postCommentDispatch(undefined, modifyData);
              if (resp) {
                const { status, message } = resp;
                (status &&
                  toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )) ||
                  toast.error(
                    <p className="toast-text-alignment">{message}</p>,
                    errorToastStyle
                  );
                isFunction(callApiOnSuccess) && callApiOnSuccess();
                this.setState(
                  prevState => ({
                    isCommentLoading:
                      (status && STATUS.SUCCESS) || STATUS.ERROR,
                    comment: "",
                    files: [],
                    reset: true,
                    error: {
                      ...prevState.error,
                      comment: {}
                    }
                  }),
                  () => {
                    this.setState({
                      reset: false
                    });
                  }
                );
              } else {
                toast.error(
                  <p className="toast-text-alignment">
                    {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
                  </p>,
                  errorToastStyle
                );
              }
            }
          );
        } else {
          const modifyData = modifyDataForPost({ files, comment, id });
          this.setState(
            {
              isCommentLoading: STATUS.LOADING
            },
            async () => {
              const resp = await postCommentDispatch(undefined, modifyData);
              if (resp) {
                const { status, message } = resp;
                (status &&
                  toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )) ||
                  toast.error(
                    <p className="toast-text-alignment">{message}</p>,
                    errorToastStyle
                  );
                isFunction(callApiOnSuccess) && callApiOnSuccess();
                this.setState(
                  prevState => ({
                    isCommentLoading:
                      (status && STATUS.SUCCESS) || STATUS.ERROR,
                    comment: "",
                    files: [],
                    reset: true,
                    error: {
                      ...prevState.error,
                      comment: {}
                    }
                  }),
                  () => {
                    this.setState({
                      reset: false
                    });
                  }
                );
              } else {
                toast.error(
                  <p className="toast-text-alignment">
                    {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
                  </p>,
                  errorToastStyle
                );
              }
            }
          );
        }
      }
    } else {
      if (!plainText) {
        this.setState(prevState => ({
          languageError: false,
          pasteError: false,
          textvalidation: false,
          error: {
            ...prevState.error,
            comment: {
              error: true,
              message: ERROR_MSG.DEFAULT_MSG
            }
          }
        }));
      } else {
        if (ministryOrState) {
          //console.log(ministryOrState,tentativeResolutionDateMandatory,CR 393 Changes)
          const modifyDate =
            tenitiveIssueResolveDate == "" ||
            tenitiveIssueResolveDate == undefined
              ? tenitiveIssueResolveDate
              : this.extractDate(tenitiveIssueResolveDate);
          //console.log(tenitiveIssueResolveDate)
          const modifyData = modifyDataForPost({
            files,
            comment,
            id,
            modifyDate
          });
          this.setState(
            {
              isCommentLoading: STATUS.LOADING
            },
            async () => {
              const resp = await postCommentDispatch(undefined, modifyData);
              if (resp) {
                const { status, message } = resp;
                (status &&
                  toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )) ||
                  toast.error(
                    <p className="toast-text-alignment">{message}</p>,
                    errorToastStyle
                  );
                isFunction(callApiOnSuccess) && callApiOnSuccess();
                this.setState(
                  prevState => ({
                    isCommentLoading:
                      (status && STATUS.SUCCESS) || STATUS.ERROR,
                    comment: "",
                    files: [],
                    reset: true,
                    error: {
                      ...prevState.error,
                      comment: {}
                    }
                  }),
                  () => {
                    this.setState({
                      reset: false
                    });
                  }
                );
              } else {
                toast.error(
                  <p className="toast-text-alignment">
                    {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
                  </p>,
                  errorToastStyle
                );
              }
            }
          );
        } else {
          const modifyData = modifyDataForPost({ files, comment, id });
          this.setState(
            {
              isCommentLoading: STATUS.LOADING
            },
            async () => {
              const resp = await postCommentDispatch(undefined, modifyData);
              if (resp) {
                const { status, message } = resp;
                (status &&
                  toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )) ||
                  toast.error(
                    <p className="toast-text-alignment">{message}</p>,
                    errorToastStyle
                  );
                isFunction(callApiOnSuccess) && callApiOnSuccess();
                this.setState(
                  prevState => ({
                    isCommentLoading:
                      (status && STATUS.SUCCESS) || STATUS.ERROR,
                    comment: "",
                    files: [],
                    reset: true,
                    error: {
                      ...prevState.error,
                      comment: {}
                    }
                  }),
                  () => {
                    this.setState({
                      reset: false
                    });
                  }
                );
              } else {
                toast.error(
                  <p className="toast-text-alignment">
                    {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
                  </p>,
                  errorToastStyle
                );
              }
            }
          );
        }
      }
    }
  };

  //
  onActionClick = value => {
    const { name, actionType } = value;
    this.setState({
      action: name,
      actionType
    });
  };

  // action buttons
  createTemplateForAction = () => {
    const { actionsData, issueDetails } = this.props;
    const actions =
      get(actionsData, "actions") || get(issueDetails, "actions") || [];
    return actions.map((value, index) => {
      return (
        get(value, "name") && (
          <>
            <ToolTip text={get(value, "description")}>
              <Button
                className={`${severity[
                  get(value, "workflowActionSeverity", "")
                ] || severity.default} no-padding-new`}
                onClick={e => {
                  this.onActionClick(value);
                }}
                key={`button-${index}`}
              >
                {get(value, "name", "NA")}
              </Button>
            </ToolTip>
          </>
        )
      );
    });
  };

  onDelete = e => {
    const { resetAction } = this.props;
    resetAction(e);
  };

  // set issue status
  setIssueStatus = async e => {
    const { action } = this.state;
    const {
      setIssueStatusDispatch,
      issueDetails = {},
      callApiOnSuccess
    } = this.props;
    const resp = await setIssueStatusDispatch(undefined, {
      action,
      issueCommentCO: {
        issueId: get(issueDetails, "id", null)
      }
    });
    if (resp) {
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      typeof callApiOnSuccess === "function" && callApiOnSuccess();
      this.setState({
        action: ""
      });
    }
  };

  handleClose = () => {
    this.setState({
      action: null
    });
  };

  getImageStatus = status => {
    this.setState({
      imageStatus: status
    });
  };

  onVerifyProject = () => {
    const { issueDetails, callApiOnSuccess } = this.props;
    this.setState(
      {
        isProjectVerifing: STATUS.LOADING
      },
      async () => {
        const response = await changeProjectStatus(undefined, {
          comment: "Project is verified.",
          projectId: issueDetails && issueDetails.project.id,
          projectStatus: "VERIFIED",
          isIssueVerified: true
        });
        const { data } = response;
        data.status
          ? toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">{data.message}</p>,
              errorToastStyle
            );
        this.setState(
          { isProjectVerifing: false, action: null, actionType: null },
          () => {
            callApiOnSuccess && callApiOnSuccess();
          }
        );
      }
    );
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      //console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    //console.log(this.state.files)
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  unHoldIssue = async () => {
    let {
      issueDetails: { id },
      unHoldIssueAction,
      callApiOnSuccess
    } = this.props;

    let resp = await unHoldIssueAction(id);
    if (resp) {
      this.setState(
        { isProjectVerifing: false, action: null, actionType: null },
        () => {
          callApiOnSuccess && callApiOnSuccess();
        }
      );
    }
  };
  handleCloseAddDecisionConfirmationModal = () => {
    this.setState({
      showAddDecisionConfirmationModal: false
    });
  };

  showAddDecisionConfirmationModal = () => {
    const {
      issueDetails,
      defaultOpen,
      callApiOnSuccess,
      filterArray,
      meetingListData
    } = this.props;
    const {
      agendasAssociatedWithIssue,
      showAddDecisionConfirmationModal
    } = this.state;
    return agendasAssociatedWithIssue.length !== 0 ? (
      <>
        <AddDecisionConfirmationModal
          show={showAddDecisionConfirmationModal}
          handleClose={this.handleCloseAddDecisionConfirmationModal}
          issueDetails={issueDetails}
          defaultOpen={defaultOpen}
          callApiOnSuccess={callApiOnSuccess}
          filterArray={filterArray}
          meetingListData={meetingListData}
          agendasAssociatedWithIssue={agendasAssociatedWithIssue}
          showAddDecisionConfirmationModal={showAddDecisionConfirmationModal}
        />
      </>
    ) : (
      <>
        <AddDecision
          show={true}
          meetingListData={get(meetingListData, "data")}
          handleClose={() =>
            this.setState({
              showAddDecisionConfirmationModal: false
            })
          }
          issues={issueDetails}
          project={
            get(issueDetails, "project") || get(issueDetails, "projectIssueDTO")
          }
          callApiOnSuccess={callApiOnSuccess}
          defaultOpen={defaultOpen}
          issueListStatus={true}
          filterArray={filterArray}
          showSaveAsDraft={false}
          callFromIssueAction={true}
        />
      </>
    );
  };

  getAgendaListForIssue = async () => {
    const { issueDetails } = this.props;
    const response = await getAgendaIssueAction(
      undefined,
      issueDetails.id,
      this.state.checkAgenda
    );
    if (response) {
      if (response.data.data !== null) {
        this.setState({
          agendasAssociatedWithIssue: response.data.data
        });
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
    this.setState({ showAddDecisionConfirmationModal: true });
  };
  inputLanguage = event => {
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    if (window.event.inputType !== "insertFromPaste") {
      if (
        !event.target.value.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE"
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          pasteError: false
        });
      }
    }
  };

  pasteLanguage = () => {
    // console.log("In paste language function");
    var cleanText = this.state.comment;
    // let cleanText = text
    //   .replace(/(<p><br\s*\/?><\/p>){2,}/gi, '<p><br></p>')
    //   .replace(/&nbsp;/g, ' ');
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    var nonEnglishChars = cleanText.replace(
      /[a-zA-Z0-9\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–——]/g,
      ""
    ).length; // Count non-English characters
    var alphanumericWithSpecial = cleanText.replace(
      /[^a-zA-Z0-9\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–—]/g,
      ""
    );

    if (
      nonEnglishChars > 0 &&
      (!cleanText.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE")
    ) {
      const originalComment = this.state.comment;
      const filteredText = originalComment.replace(
        /[^a-zA-Z\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–—]/g,
        "^"
      );
      if (filteredText.length > 8) {
        const stringWithSingleSpace = filteredText.replace(/\s+/g, " ");
        this.setState({
          comment: stringWithSingleSpace,
          languageError: true,
          textvalidation: true
        });
      } else {
        this.setState({ comment: "", languageError: true });
      }
    } else {
      this.setState({
        comment: cleanText,
        languageError: false,
        textvalidation: true
      });
      if (
        !cleanText.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE"
      ) {
        let { filterString, hasBadValue } = handlePaste(this.state.comment);
        if (hasBadValue === true) {
          this.setState({
            pasteError: hasBadValue,
            comment: filterString
          });
        }
      }
    }
  };
  updateStatus = () => {
    localStorage.setItem("DisplayButton", "1");
    const { actionsData, issueDetails } = this.props;
    const actionsInfo = actionsData || issueDetails || {};
    this.setState({
      updatestatusloader: true,
      textvalidation: true,
      comment: "",
      rejectissue: actionsInfo.issueStatus,
      tenitiveIssueResolveDate: "",
      tenitiveDateError: true
    });
    setTimeout(() => {
      this.setState({
        displaystatus: 1,
        updatestatusloader: false
      });
    }, 1200);
  };
  updateStatusclose = () => {
    this.setState({
      displaystatus: 0,
      textvalidation: true,
      comment: "",
      tenitiveIssueResolveDate: "",
      tenitiveDateError: true
    });
  };
  onTenitiveChange = value => {
    this.setState({
      tenitiveIssueResolveDate: value,
      tenitiveDateError: true
    });
  };

  handleChange(html, event) {
    console.log(html, event);
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");

    // let cleanHtml = html   updated one
    //   .replace(/^(<p><br><\/p>)+/g, '')
    //   .replace(/(<p><br><\/p>){2,}/g, '<p><br></p>');

    //let cleanHtml = html.replace(/^(<p><br><\/p>)+$/g, '');
    const plainText = html.replace(/<[^>]*>/g, "").trim();
    const isBlank = !plainText || /^(<p><br><\/p>)+$/g.test(html); // only empty <p><br></p>

    // if (isBlank) {
    //   this.setState({
    //     textvalidation: false,
    //     comment: html,
    //   });
    //   return;
    // }

    const englishRegex = /^[A-Za-z\s.,!?'"()]*$/;
    //const englishRegex = /^[A-Za-z0-9\s.,!?'"()[\]:;’-]*$/;
    const hindiRegex = /[\u0900-\u097F]/;
    if (englishRegex.test(plainText)) {
      console.log("matched english");
      if (html !== this.state.comment) {
        this.setState({
          languageError: false,
          pasteError: false,
          comment: html,
          textvalidation: true
        });
      }
    } else {
      console.warn("Hindi characters are not allowed.");
      if (html !== this.state.comment) {
        this.setState(
          {
            comment: html,
            textvalidation: false
          },
          () => {
            this.pasteLanguage();
          }
        );
      }
    }
  }
  toggleApprovePopUp = () => {
    this.setState(prevState => ({
      showCommentPopUp: !prevState.showCommentPopUp
    }));
  };
  render() {
    const {
      action,
      comment,
      error,
      files,
      actionType,
      isProjectVerifing,
      isCommentLoading,
      imageStatus,
      toggleAttachementDisplay,
      canUploadVideo,
      pasteError,
      languageError,
      showCommentPopUp
    } = this.state;
    const {
      issueDetails,
      replyActionDispatch,
      issueClarificationDispatch,
      defaultOpen,
      meetingListData,
      actionsData,
      callApiOnSuccess,
      isLoading,
      isApiLoading,
      filterArray,
      handleOnClick,
      Displaybuttons,
      BackgroundColor,
      issueStatus
    } = this.props;

    const actionsInfo = actionsData || issueDetails || {};
    const {
      actions,
      askForClarificationList,
      replyToList,
      markAsDuplicateList
    } = actionsData || issueDetails || {};
    const { project, projectIssueDTO } = actionsInfo;
    const projectStatus =
      get(project, "status") || get(projectIssueDTO, "status");
    const isActionAvailable = (actions || []).find(value => {
      return value && value.name === action;
    });
    const groupCategory = getLocalstorage("groupCategory");
    const CentralDept_UserName = getLocalstorage("name");
    const isCentralDeptUser = get(project, "projectPPList", []).some(
      item => item.name === CentralDept_UserName
    );
    // console.log(isCentralDeptUser)
    const privateProject = get(issueDetails, "project.implMode") == "PRIVATE";

    const issueCreatorName_CentralDept = get(issueDetails, "issueCreatorName");
    //  console.log(CentralDept_UserName===issueCreatorName_CentralDept)
    const privateProjectSM =
      get(issueDetails, "project.sponsoredByid") == 13758;

    const toolbarConfig = {
      toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <React.Fragment>
        {showCommentPopUp &&
        (groupCategory === "PP" ||
          groupCategory === "OTHER" ||
          (groupCategory == "CENTRAL_DEPARTMENT" && isCentralDeptUser)) ? (
          // &&
          // CentralDept_UserName === issueCreatorName_CentralDept
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.onPostComment}
            closeHandler={this.toggleApprovePopUp}
            issueUpdateStatus={true}
            mainContent={
              privateProject || privateProjectSM
                ? null
                : "The status update requires approval from the Nodal Officer. Until approved, it will be registered as an ‘Unapproved' status."
            }
            content={"Are you sure you want to update the status?"}
          />
        ) : null}
        {showCommentPopUp &&
        groupCategory !== "PP" &&
        groupCategory !== "OTHER" &&
        !(groupCategory == "CENTRAL_DEPARTMENT" && isCentralDeptUser) ? (
          // !(
          //   groupCategory === "CENTRAL_DEPARTMENT" &&
          //   CentralDept_UserName === issueCreatorName_CentralDept
          // )

          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.onPostComment}
            closeHandler={this.toggleApprovePopUp}
            issueUpdateStatus={true}
            content={"Are you sure you want to update the status?"}
          />
        ) : null}
        {this.state.displaystatus == 0 ||
        localStorage.getItem("DisplayButton") == 0 ? (
          <>
            <ToolTip text={MESSAGES_CONSTANT["updateStatus"]}>
              <Button
                style={{
                  display:
                    Displaybuttons == 1 //||
                      ? //||(issueDetails.status=="Resolved" && this.props.AdminCredential==true)
                        // (issueDetails.status == "Resolved" &&
                        //   groupCategory == "PP") ||
                        // (issueDetails.status == "Resolved" &&
                        //   issueDetails.creatorName == ppname) ||
                        // (issueDetails.issueStatus == "RESOLVED" &&
                        //   groupCategory == "PP") ||
                        // (issueDetails.issueStatus == "RESOLVED" &&
                        //   issueDetails.issueCreatorName == ppname) //Based On Task 166
                        //||(issueDetails.issueStatus=="RESOLVED" && this.props.AdminCredential==true)
                        "none"
                      : null,
                  position:
                    get(actionsInfo, "markAsDuplicate") ||
                    this.props.issueStatus ||
                    issueDetails.actions.find(
                      item => item.name === "RESOLVED & SEND TO PMG"
                    ) ||
                    issueDetails.status == "Resolved" ||
                    issueDetails.issueStatus == "RESOLVED" ||
                    (issueDetails.status == "On Hold" &&
                      groupCategory == "PP") ||
                    (issueDetails.issueStatus == "HOLD" &&
                      groupCategory == "PP") ||
                    (issueDetails.issueStatus == "PENDING_WITH_STATE_PMG" &&
                      groupCategory == "STATE") ||
                    issueDetails.askForClarificationList
                      ? null
                      : "absolute"
                  //height: get(actionsInfo, "markAsDuplicate") ? null : 42
                  // paddingLeft:BackgroundColor=="white"?"3%":null
                }}
                className={`new-updatestatus-btn no-padding-new shadow-none align-self-end`}
                onClick={this.updateStatus}
              >
                Update Status <img className="uparrowicon" src={uparrow} />
              </Button>
            </ToolTip>
          </>
        ) : (
          <>
            <ToolTip text={MESSAGES_CONSTANT["updateStatus"]}>
              <Button
                style={{
                  // paddingLeft:BackgroundColor=="white"?"3%":null,
                  display: Displaybuttons == 1 ? "none" : null,
                  position:
                    get(actionsInfo, "markAsDuplicate") ||
                    this.state.rejectissue == "REJECT" ||
                    issueDetails.actions.find(
                      item => item.name === "RESOLVED & SEND TO PMG"
                    ) ||
                    this.props.issueStatus ||
                    issueDetails.status == "Resolved" ||
                    issueDetails.issueStatus == "RESOLVED" ||
                    (issueDetails.status == "On Hold" &&
                      groupCategory == "PP") ||
                    (issueDetails.issueStatus == "HOLD" &&
                      groupCategory == "PP") ||
                    (issueDetails.issueStatus == "PENDING_WITH_STATE_PMG" &&
                      groupCategory == "STATE") ||
                    issueDetails.askForClarificationList
                      ? null
                      : "absolute"
                  //height: get(actionsInfo, "markAsDuplicate") ? null : 42
                }}
                className={`new-updatestatus-disable-btn no-padding-new shadow-none align-self-end`}
              >
                Update Status <img className="uparrowicon" src={downarrow} />
              </Button>
            </ToolTip>
          </>
        )}

        <DisplayByPermission display={!action || (!action && defaultOpen)}>
          <DisplayByPermission display={get(actionsInfo, "markAsDuplicate")}>
            <ToolTip text={MESSAGES_CONSTANT["markAsDuplicate"]}>
              <Button
                className={`${
                  get(actionsInfo, "markAsDuplicate") &&
                  issueDetails.actions.find(
                    item =>
                      item.name === "RESOLVED & SEND TO PMG" ||
                      item.name === "RESOLVED AND SEND TO STATE PMG"
                  )
                    ? "btn-orange-invert no-padding-new button-more-issue"
                    : get(actionsInfo, "markAsDuplicate")
                    ? "btn-orange-invert no-padding-new button-more-issuemark-as-dup-btn"
                    : "btn-orange-invert no-padding-new button-more-issue"
                }`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.onChangemarkAsdup(
                    FIXED_ACTIONS["Mark_As_Duplicate"],
                    "action"
                  );
                }}
                style={{
                  display: this.props.Displaybuttons == 1 ? "none" : null
                }}
              >
                Mark Duplicate
              </Button>
            </ToolTip>
          </DisplayByPermission>
        </DisplayByPermission>
        <DisplayByPermission
          display={action === FIXED_ACTIONS["Mark_As_Duplicate"]}
        >
          <MarkAsDuplicate
            headerText="Mark As Duplicate"
            issueDetails={issueDetails}
            options={
              markAsDuplicateList && markAsDuplicateList.length
                ? markAsDuplicateList
                : []
            }
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
            markDuplicateBTN={this.handleMarkBTN}
          />
        </DisplayByPermission>
        {/* <LoaderPage
          loading={
            isCommentLoading === STATUS.LOADING ||
            imageStatus === STATUS.LOADING ||
            isApiLoading === STATUS.LOADING ||
            isProjectVerifing ||
            this.state.updatestatusloader
          }
        /> */}

        <DisplayByPermission display={!action || (!action && defaultOpen)}>
          {this.state.displaystatus == 1 ? (
            <div
              className="updatestatusanimation"
              style={{
                display:
                  Displaybuttons == 1 ||
                  localStorage.getItem("DisplayButton") == 0
                    ? "none"
                    : null
              }}
            >
              <DisplayByPermission display={true}>
                <div className="d-flex update-resolution-comment-tooltip">
                  <div
                    className="update-heading"
                    style={{ paddingLeft: "0", color: "#525252" }}
                  >
                    Update Status
                  </div>

                  <TooltipComponent
                    classes="add_issue_tooltip"
                    smallIconInfo={InfoIcon}
                    placement="right"
                    content={
                      <>
                        Latest update, indicate latest pendency in values, for
                        eg: <br /> pending/total (km, Ha, units, etc), efforts
                        undertaken to resolve <br /> issue by User Agency and
                        Sponsoring Ministry (including at the
                        <br />
                        level of head of User Agency and Sponsoring Ministry),
                        timeline
                        <br />
                        for completing pending tasks (if any)
                      </>
                    }
                  />
                  <div className="deleteicon">
                    <img src={DeleteIcon} onClick={this.updateStatusclose} />
                  </div>
                </div>
                <Form className="update-status-form update-status-form-quill">
                  {issueDetails.ministryOrState && (
                    <div className="update-status-form-content">
                      <Form.Group className="field-select field-to">
                        <Form.Label>
                          Tentative Issue Resolution Date{" "}
                          <span
                            className="required"
                            style={{
                              visibility: issueDetails.tentativeResolutionDateMandatory
                                ? null
                                : "hidden"
                            }}
                          >
                            *
                          </span>
                        </Form.Label>
                        <div className="extra-div" />
                        <div
                          className="date-picker-container"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "-webkit-fill-available",
                            paddingLeft: "60px"
                          }}
                        >
                          <DatePicker
                            style={{
                              width: "500px"
                            }}
                            selected={this.state.tenitiveIssueResolveDate}
                            ifValue={
                              this.state.tenitiveIssueResolveDate ? true : false
                            }
                            onChange={value => {
                              this.onTenitiveChange(value);
                            }}
                            isInvalid={!this.state.tenitiveDateError}
                          />
                        </div>
                      </Form.Group>
                    </div>
                  )}
                  <div className="quill-field">
                    <ReactQuill
                      value={this.state.comment}
                      onChange={(html, event) => this.handleChange(html, event)}
                      theme="snow"
                      modules={toolbarConfig}
                      formats={formats}
                      bounds={".app"}
                      //placeholder={`Latest update, indicate latest pendency in values, for eg: pending/total (km, Ha, units, etc), efforts undertaken to resolve issue by User Agency and Sponsoring Ministry (including at the level of head of User Agency and Sponsoring Ministry), timeline for completing pending tasks (if any)`}
                      ref={el => {
                        this.reactQuillRef = el;
                      }}
                    />
                    {comment == "" || comment == "<p><br></p>" ? (
                      <>
                        <label
                          for="some-id"
                          class="quill-editor-txt-label textfield__label textfield__label--required"
                        >
                          Latest update, indicate latest pendency in values, for
                          eg: pending/total (km, Ha, units, etc), efforts
                          undertaken to resolve issue by User Agency and
                          Sponsoring Ministry (including at the level of head of
                          User Agency and Sponsoring Ministry), timeline for
                          completing pending tasks (if any)
                        </label>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {toggleAttachementDisplay ? (
                    <UploadAttachmentsWithTitleComponent
                      displayModal={toggleAttachementDisplay}
                      onCloseModal={this.onToggleAttachment}
                      fileFormats={FILE_FORMATS}
                      onSubmit={this.onSuccessUploadOfAttachmets}
                      canUploadVideo={canUploadVideo}
                      //handleDisplayTitle={this.handleDisplayTitle}
                      //displaytitle={true}
                    />
                  ) : null}

                  <Form.Control.Feedback type="invalid">
                    {languageError === true ||
                    (pasteError === true && comment !== "")
                      ? ""
                      : get(error, "comment.message")}
                  </Form.Control.Feedback>
                  {/* <Form.Group
                    controlId="exampleForm.ControlTextarea1"
                    className={
                      `update-comment-area issue-detail-actions`
                    }
                    style={{
                      //border: "1.5px solid #CED7F4",
                      marginTop: "0.5%",
                      borderRadius: 0,
                      minHeight: 106,
                      borderBottom: 0,
                      paddingLeft: 20,
                      paddingRight: 20,
                    }}
                  >
                    <Field
                      as="textarea"
                      keyName="comment"
                      rows="3"
                      value={comment}
                      id="some-id"
                      className="add-comment"
                      maxLength="500"
                      // placeholder={`Latest update, indicate latest pendency in values, for eg: pending/total (km, Ha, units, etc), efforts undertaken to resolve issue, timeline for completing pending tasks (if any).${this.state.asterik}`}
                      onInput={this.inputLanguage}
                      onChange={this.onChange.bind(this)}
                      onError={this.onError.bind(this)}
                      required
                      onBlur={this.onBlur}
                      //isInvalid={get(error, "comment.error")}
                    />

                    {comment == "" ? (
                      <>
                        <label
                          for="some-id"
                          class="textfield__label textfield__label--required"
                        >
                          Latest update, indicate latest pendency in values, for
                          eg: pending/total (km, Ha, units, etc), efforts
                          undertaken to resolve issue by User Agency and
                          Sponsoring Ministry (including at the level of head of
                          User Agency and Sponsoring Ministry), timeline for
                          completing pending tasks (if any)
                        </label>
                      </>
                    ) : (
                      <></>
                    )}

                    {toggleAttachementDisplay ? (
                      <UploadAttachmentsWithTitleComponent
                        displayModal={toggleAttachementDisplay}
                        onCloseModal={this.onToggleAttachment}
                        fileFormats={FILE_FORMATS}
                        onSubmit={this.onSuccessUploadOfAttachmets}
                        canUploadVideo={canUploadVideo}
                      />
                    ) : null}

                    <Form.Control.Feedback type="invalid">
                      {languageError === true ||
                      (pasteError === true && comment !== "")
                        ? ""
                        : get(error, "comment.message")}
                    </Form.Control.Feedback>
                  </Form.Group> */}

                  {this.state.files.length == 0 ? null : (
                    <>
                      <div className="newdiv">
                        <div className="newline" />
                      </div>
                    </>
                  )}
                  {this.state.files.length === 0 ? null : (
                    <div className="new-attachment-update-status">
                      <DisplayAttachments
                        filesArr={files}
                        onRemoveFile={this.onRemoveFile}
                        addAttchementRequired={false}
                        classes="attachments"
                        marginleft={this.props.marginleft}
                        updatestatusstyle={true}
                      />
                    </div>
                  )}

                  <Form.Group className="field-attachment issue-detail-action">
                    <div className="attachment-box attachment-box-ustatus">
                      <div
                        className="add-attachment"
                        onClick={this.onToggleAttachment}
                        style={{ marginLeft: 2 }}
                      >
                        <div className="add-attachment-button">
                          <Image src={IconPin} alt="Attachment Icon" />
                          Add Attachment
                        </div>
                      </div>
                    </div>
                    <div className="button-group post-comment">
                      <Button
                        className={`btn-orange no-padding`}
                        onClick={this.handleSubmitClick}
                        style={{ marginTop: "3%", padding: "12px 20px" }}
                        disabled={
                          500 - htmlToFormattedText(comment).length < 0
                            ? true
                            : false
                        }
                      >
                        {/* <div className="post-icon orange" /> */}
                        SUBMIT
                      </Button>
                    </div>
                  </Form.Group>
                </Form>
                <div style={{ marginTop: "-2%" }} />
                <Row
                  className="align-action justify-content-between"
                  style={{
                    background:
                      BackgroundColor == "white" ? "white" : "#f4f8fc",
                    marginTop: "2%"
                  }}
                >
                  <span className="remaining-char">
                    Remaining characters :{" "}
                    <span
                      className="remaining-char"
                      style={{
                        color:
                          500 - htmlToFormattedText(comment).length < 0
                            ? "red"
                            : "#848584"
                      }}
                    >
                      {500 - htmlToFormattedText(comment).length}
                    </span>
                    {/* {comment
                      ? MAX_CHARACTER_LIMIT - comment.length
                      : MAX_CHARACTER_LIMIT} */}
                  </span>

                  {languageError || (pasteError && comment !== "") ? (
                    <div className="warning">
                      <Image src={CircleWithExclamation} />
                      Only English language is supported.
                    </div>
                  ) : (
                    <></>
                  )}
                </Row>
                <Row
                  className="align-action justify-content-between"
                  style={{
                    background:
                      BackgroundColor == "white" ? "white" : "#f4f8fc",
                    display:
                      this.state.textvalidation && this.state.tenitiveDateError
                        ? "none"
                        : null
                  }}
                >
                  <div class="error" style={{ paddingTop: "0.5%", padding: 0 }}>
                    Mandatory fields are missing
                  </div>
                </Row>
              </DisplayByPermission>
            </div>
          ) : null}
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.issueActionReducer.isApiLoading,
    meetingStatus: state.issueDetailsReducer.meetingStatus,
    meetingListData: state.issueDetailsReducer.meetingListData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIssueStatusDispatch: setIssueStatusAction,
      postCommentDispatch: postCommentAction,
      getIssueListDispatch: getIssueList,
      replyActionDispatch: replyAction,
      issueClarificationDispatch: issueClarificationAction,
      getIssueMeetingByIdDispatch: getIssueMeetingByIdAction,
      getIssueDetailsDispatch: getIssueDetails,
      getProjectDetails,
      unHoldIssueAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueUpdateStatus)
);
